import RepTestimonialAvatar3Svg from '../landing/images/pro-testimonial-avatar3.svg';

export const PartnerLandingTestimonialSection = () => (
  <section className='py-16 sm:py-20 px-4 sm:px-8 bg-secondary-brand-25'>
    <div className='max-w-[1216px] mx-auto'>
      <blockquote className='text-center mb-8 text-2xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-[-0.02em] text-gray-700 font-sans'>
        Professionals helped us define the future path for our data strategy. Now, our lead
        conversion time is down by 60%, leading to more customers and greater efficiency across
        every project.
      </blockquote>
      <div className='flex flex-col items-center'>
        <img
          src={RepTestimonialAvatar3Svg}
          alt='Akinyi Awora'
          className='w-16 h-16 rounded-full object-cover mb-4'
        />
        <div className='text-gray-700 text-lg font-semibold'>Akinyi Awora</div>
        <div className='text-gray-400'>Co-Founder & President, Kadana Foundation</div>
      </div>
    </div>
  </section>
);
